<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-cog"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{'configuracao_da_empresa' | translate}}</h1>
    <p class="header-subtitle">{{'configuracao_da_empresa_subtitulo' | translate}}</p>
  </div>
</div>

<!-- Loading -->
<div *ngIf="carregandoDados" class="loading-container">
  <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
</div>

<div *ngIf="!carregandoDados" class="container mt-1 mb-2">
  <div class="form-container">

    <p-tabView [(activeIndex)]="activeIndex">


      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-info-circle tab-icon"></i>
          <span>{{'informacoes_gerais' | translate}}</span>
        </ng-template>
        <div *ngIf="activeIndex === 0">
          <div class="main-div form-div">
            <div class="form-container">
              <div class="form-column">
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'Nome_da_Empresa' | translate}} <span class="text-red-500">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.nome" placeholder="{{'nome' | translate}}"
                    class="input-field" [class.error-field]="isFormSubmitted && !form.nome" />
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'email' | translate}} <span class="text-red-500">*</span></label>
                  <input type="email" pInputText [(ngModel)]="form.email" placeholder="{{'email' | translate}}"
                    class="input-field" [class.error-field]="isFormSubmitted && !form.email" />
                </div>
                <div class="form-item form-item-25">
                  <app-phone-input
                    [(telefone)]="form.telefone"
                    [(ddi)]="paisSelecionado"
                    [label]="('telefone_empresa' | translate)"
                    [placeholder]="'(021) 123-456789'"
                    [required]="true"
                    [class.error-field-phone]="isFormSubmitted && !form.telefone">
                  </app-phone-input>
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'endereco' | translate}}</label>
                  <input type="text" pInputText [(ngModel)]="form.endereco" placeholder="{{'endereco' | translate}}"
                    class="input-field" />
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'cidade' | translate}} <span class="text-red-500">*</span></label>
                  <p-dropdown id="selecionarCidade" [options]="cidadeList" [(ngModel)]="form.cidade" optionLabel="label"
                    placeholder="{{'selecionar' | translate}}" [filter]="true" filterBy="label" [showClear]="true"
                    (onChange)="onCidadeChange($event)" [class.error-field]="isFormSubmitted && !form.cidade"
                    appendTo="body" panelStyleClass="ddi-dropdown-panel-erp" scrollHeight="340px"></p-dropdown>
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'Estado' | translate}}</label>
                  <input type="text" pInputText [value]="estadoSelecionado" disabled readonly class="input-field" />
                </div>
              <div class="form-item form-item-25">
  <label class="pb-2">{{'Logo_empresa' | translate}}</label>

  <div class="logo-upload-improved">
    <div class="upload-area" (click)="fileInput.click()">
      <div class="upload-content">
        <!-- Conteúdo de upload - só mostra quando não há logo -->
        <div *ngIf="!hasLogo" class="upload-content-wrapper">
          <div class="upload-icon">
            <i class="pi pi-image"></i>
          </div>
          <div class="upload-text">
            <p class="upload-title">{{'Subir_logo_empresa' | translate}}</p>
            <p class="upload-subtitle">
              {{'Pressione_icone_para_selecionar_imagem' | translate}}
              <span class="ratio-hint">({{'relacao_um_por_um' | translate}})</span>
            </p>
          </div>

          <!-- Nome do arquivo -->
          <div class="file-name" *ngIf="fileName">
            <i class="pi pi-file"></i>
            <span>{{ fileName }}</span>
          </div>
        </div>

        <!-- Preview da imagem - mostra quando há logo -->
        <div class="image-preview" *ngIf="hasLogo">
          <img [src]="imageSrc || (env.imgHost + '/' + empresaData?.id + '/configuracao_empresa/' + empresaData?.logo)"
               alt="Logo da empresa"
               class="logo-preview">
          <button type="button" (click)="removeImage($event)" class="btn-remove-image">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </div>

    <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" style="display: none;" />
  </div>
</div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-briefcase tab-icon"></i>
          <span>{{'informacoes_do_negocio' | translate}}</span>
        </ng-template>
        <div *ngIf="activeIndex === 1">
          <div class="main-div form-div">
            <div class="form-container">
              <div class="form-column">
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'Nome_Comercial' | translate}} <span class="text-red-500">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.fantasia"
                    placeholder="{{'nome_fantasia' | translate}}" class="input-field" [class.error-field]="isFormSubmitted && !form.fantasia" />
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'ruc' | translate}} <span class="text-red-500">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.ruc" placeholder="{{'ruc_da_empresa' | translate}}"
                    class="input-field" [class.error-field]="(isFormSubmitted && !form.ruc) || avisoRuc"
                    inputmode="tel" (input)="onRucInput($event)" />
                  <small *ngIf="avisoRuc" class="p-error">{{ avisoRuc }}</small>
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'moeda_multipla' | translate}} <span class="text-red-500">*</span></label>
                  <p-dropdown id="moeda_multipla" [options]="utilizaMultiMoeda" [(ngModel)]="form.utilizaMultiMoeda"
                    optionLabel="label" optionValue="value" placeholder="{{ 'selecionar' | translate }}"
                    [showClear]="false" [disabled]="true">
                    <ng-template pTemplate="selectedItem">
                      <span *ngIf="form.utilizaMultiMoeda !== null && form.utilizaMultiMoeda !== undefined">
                        {{ (form.utilizaMultiMoeda ? 'Sim' : 'Nao') | translate }}
                      </span>
                    </ng-template>
                    <ng-template let-option pTemplate="item">
                      {{ (option.value ? 'Sim' : 'Nao') | translate }}
                    </ng-template>
                  </p-dropdown>

                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'moeda' | translate}} <span class="text-red-500">*</span></label>
                  <p-dropdown id="moeda" [options]="moeda" [(ngModel)]="form.moeda" optionLabel="label"
                    placeholder="{{ 'selecionar' | translate }}" [disabled]="true">
                  </p-dropdown>

                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'sobre_o_negocio' | translate}}</label>
                  <input type="text" pInputText [(ngModel)]="form.informacaoNegocio"
                    placeholder="{{'sobre_o_negocio' | translate}}" class="input-field" />
                </div>
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'rodape' | translate}}</label>
                  <input type="text" pInputText [(ngModel)]="form.rodape" placeholder="{{'rodape' | translate}}"
                    class="input-field" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
<p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-dollar tab-icon"></i>
          <span>{{'atividade_economica' | translate}}</span>
        </ng-template>
  <div *ngIf="activeIndex === 2">
    <div class="main-div form-div">
      <div class="form-container">
        <div class="form-column">
          <div class="form-group">
            <label>{{'atividade_economica' | translate}}</label>

            <p-dialog header="{{'adicionar_atividade_economica' | translate}}" [(visible)]="visible" [modal]="true"
              [style]="{ width: 'auto' }">
              <app-atividade-economica-add [isDialog]="true"
                [atividadesEconomicasList]="form.atividadesEconomicas" (visibleChange)="dialog($event)"
                (atividadesEconomicas)="addAtividadeEconomica($event)" [visible]="visible">
              </app-atividade-economica-add>
            </p-dialog>
            <app-atividade-economica-add [isDialog]="false" [atividadesEconomicasList]="form.atividadesEconomicas"
              (visibleChange)="dialog($event)"
              (atividadesEconomicas)="addAtividadeEconomica($event)">
            </app-atividade-economica-add>
          </div>
        </div>
      </div>
    </div>


  </div>
</p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-file tab-icon"></i>
          <span>DTE</span>
        </ng-template>
        <div *ngIf="activeIndex === 3">
          <div class="main-div form-div">
            <div class="form-container">
              <div class="form-column">

                <!-- Campos DTE existentes -->
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'codigo_estabelecimento' | translate}} <span class="text-red-500">*</span></label>
                  <input type="text" pInputText placeholder="{{'codigo_estabelecimento' | translate}}" class="input-field w-full"
                    [(ngModel)]="form.codigoEstabelecimento" [disabled]="isUploadingCertificado"
                    [class.error-field]="isFormSubmitted && !form.codigoEstabelecimento" />
                </div>

                <div class="form-item form-item-25">
                  <label class="pb-2">{{'id_csc' | translate}} <span class="text-red-500">*</span></label>
                  <input type="text" pInputText placeholder="{{'id_csc' | translate}}" class="input-field w-full" [(ngModel)]="form.idCsc"
                    [disabled]="isUploadingCertificado"
                    [class.error-field]="isFormSubmitted && !form.idCsc" />
                </div>

                <div class="form-item form-item-25">
                  <label class="pb-2">{{'csc' | translate}}</label>
                  <input type="text" pInputText [(ngModel)]="form.csc" placeholder="{{'csc' | translate}}" class="input-field w-full"
                    autocomplete="off" name="csc-dte"
                    [disabled]="isUploadingCertificado" />
                </div>



                <!-- Senha do Certificado -->
                <div class="form-item form-item-25">
                  <label class="pb-2">{{'senha_certificado' | translate}}</label>
                  <p-password [(ngModel)]="certificadoDigital.senha" [feedback]="false" [toggleMask]="true"
                    placeholder="{{'digite_senha_certificado' | translate}}"
                    autocomplete="new-password"
                    [disabled]="isUploadingCertificado">
                  </p-password>
                  <small class="text-gray-600">
                    {{'senha_certificado' | translate}}
                  </small>
                </div>


                <!-- Certificado Digital -->
                <div class="form-item form-item-50">
                  <label class="pb-2">{{'selecionar_certificado_pfx' | translate}} *</label>

                  <div class="certificate-upload-improved">
                    <div class="upload-area" [class.has-file]="certificadoDigital.arquivo"
                      [class.uploading]="isUploadingCertificado"
                      (click)="!isUploadingCertificado && certificadoFileInput.click()">

                      <div class="upload-content" *ngIf="!certificadoDigital.arquivo && !isUploadingCertificado">
                        <div class="upload-icon">
                          <i class="pi pi-file-pdf"></i>
                        </div>
                        <div class="upload-text">
                          <p class="upload-title">{{'selecionar_certificado_pfx' | translate}}</p>
                          <p class="upload-subtitle">
                            {{'formatos_aceitos' | translate}}<br>
                            {{'tamanho_maximo' | translate}}
                          </p>
                        </div>
                      </div>

                      <!-- Preview do certificado -->
                      <div class="certificate-preview" *ngIf="certificadoDigital.arquivo && !isUploadingCertificado">
                        <div class="certificate-icon">
                          <i class="pi pi-lock" [ngClass]="{
                      'text-green-500': certificadoInfo,
                      'text-yellow-500': !certificadoInfo
                    }"></i>
                        </div>
                        <div class="certificate-info">
                          <p class="file-name">{{ certificadoDigital.nomeArquivo }}</p>
                          <p class="file-size">
                            {{ formatarTamanhoArquivo(certificadoDigital.arquivo.size) }}
                          </p>
                          <p class="file-status" [ngClass]="{
                      'text-green-600': certificadoInfo,
                      'text-yellow-600': !certificadoInfo
                    }">
                            <i class="pi mr-1" [ngClass]="{
                        'pi-check-circle': certificadoInfo,
                        'pi-exclamation-circle': !certificadoInfo
                      }"></i>
                            {{ certificadoInfo ? ('processado' | translate) : ('pronto_para_envio' | translate) }}
                          </p>
                        </div>
                        <button type="button" (click)="removerCertificado(); $event.stopPropagation()"
                          class="btn-remove-certificate" [disabled]="isUploadingCertificado"
                          pTooltip="{{'remover_certificado' | translate}}" tooltipPosition="left">
                          <i class="pi pi-times"></i>
                        </button>
                      </div>

                      <!-- Loading -->
                      <div class="upload-loading" *ngIf="isUploadingCertificado">
                        <i class="pi pi-spin pi-spinner"></i>
                        <span>{{'processando_certificado' | translate}}</span>
                      </div>
                    </div>

                    <input #certificadoFileInput type="file" id="certificado-digital-file" accept=".pfx,.p12"
                      (change)="onCertificadoSelected($event)" style="display: none;"
                      [disabled]="isUploadingCertificado" />

                    <small class="text-gray-600 block mt-2">
                      <i class="pi pi-info-circle mr-1"></i>
                      {{'certificado_validado' | translate}}
                    </small>
                  </div>

                  <!-- Botões de ação -->
                  <div class="certificate-actions mt-2" *ngIf="certificadoDigital.arquivo">
                    <button pButton type="button" label="{{'testar_certificado' | translate}}" icon="pi pi-check"
                      (click)="testarCertificado()" [loading]="isUploadingCertificado"
                      class="p-button-outlined p-button-sm mr-2" [disabled]="!certificadoDigital.senha">
                    </button>

                    <button pButton type="button" label="{{'salvar_servidor' | translate}}" icon="pi pi-cloud-upload"
                      (click)="enviarCertificado()" [loading]="isUploadingCertificado"
                      class="p-button-success p-button-sm" [disabled]="!certificadoDigital.senha">
                    </button>
                  </div>
                </div>
                <!-- Status do Envio -->
                <div class="mt-3" *ngIf="isUploadingCertificado">
                  <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
                  <small class="text-blue-600 flex align-items-center gap-1 mt-1">
                    <i class="pi pi-spin pi-spinner"></i>
                    {{'processando_certificado' | translate}}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-sliders-h tab-icon"></i>
          <span>{{'outros' | translate}}</span>
        </ng-template>
        <div *ngIf="activeIndex === 4" class="main-div form-div">
          <div class="form-container">
            <div class="form-column">
              <div class="form-item form-item-25">
                <label class="pb-2">{{'regime_contabil' | translate}} <span class="text-red-500">*</span></label>
                <p-dropdown id="selecionarPerfil" [options]="tipoRegimeContabil" optionLabel="label"
                  placeholder="{{'selecionar' | translate}}" [(ngModel)]="form.tipoRegimeContabil"
                  [class.error-field]="isFormSubmitted && !form.tipoRegimeContabil">
                </p-dropdown>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Opcoes_de_Impressao' | translate}} <span class="text-red-500">*</span></label>
                <p-dropdown id="tipoImprimir" [options]="tipoImprimir" [(ngModel)]="form.tipoImprimir"
                  optionLabel="label" placeholder="{{'selecionar' | translate}}"
                  [class.error-field]="isFormSubmitted && !form.tipoImprimir"></p-dropdown>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'tipo_impressao' | translate}}
                  <span class="text-red-500" *ngIf="form.tipoImprimir?.value && form.tipoImprimir?.value !== 'NADA_A_FAZER'">*</span>
                </label>
                <p-dropdown id="tipoImpressao" [options]="tipoImpressao" [(ngModel)]="form.tipoImpressao"
                  optionLabel="label" placeholder="{{'selecionar' | translate}}"
                  [class.error-field]="isFormSubmitted && form.tipoImprimir?.value && form.tipoImprimir?.value !== 'NADA_A_FAZER' && !form.tipoImpressao"></p-dropdown>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Cliente_Padrao' | translate}} <span class="text-red-500">*</span></label>

                <p-dropdown [options]="clientes" [(ngModel)]="clienteSelecionado" optionLabel="nome"
                  [placeholder]="'selecionar' | translate" (onChange)="onClienteSelecionado(clienteSelecionado);"
                  [filter]="true" filterBy="nome" [showClear]="true"
                  [class.error-field]="isFormSubmitted && !clienteSelecionado">
                </p-dropdown>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Timbrado_preselecionado_Venda' | translate}}</label>
                <p-dropdown id="timbradoPadraoVendaId" [options]="timbrados" [(ngModel)]="timbradoVendaSelecionado"
                  (onChange)="onTimbradoChange($event, 'venda')" optionLabel="label"
                  placeholder="{{'selecionar' | translate}}"></p-dropdown>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Timbrado_preselecionado_Nota_Fiscal' | translate}} <span class="text-red-500">*</span></label>

                <p-dropdown id="timbradoPadraoNotaFiscalId" [options]="timbradosNotaFiscal"
                  (onChange)="onTimbradoChange($event, 'notaFiscal')" [(ngModel)]="timbradoNotaFiscalSelecionado"
                  optionLabel="label" placeholder="{{'selecionar' | translate}}" [showClear]="true" [filter]="true"
                  filterBy="label" [style]="{'width': '100%'}"
                  [class.error-field]="isFormSubmitted && !timbradoNotaFiscalSelecionado">
                </p-dropdown>

              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Imprimir_Ficha_do_Evento' | translate}}</label>
                <p-dropdown id="deveImprimirFicha" [options]="deveImprimirFicha" [(ngModel)]="form.deveImprimirFicha"
                  optionLabel="label" optionValue="value" placeholder="{{ 'selecionar' | translate }}"
                  [showClear]="false">

                  <ng-template pTemplate="selectedItem">
                    <span *ngIf="form.deveImprimirFicha !== null && form.deveImprimirFicha !== undefined">
                      {{ (form.deveImprimirFicha ? 'Sim' : 'Nao') | translate }}
                    </span>
                  </ng-template>

                  <ng-template let-option pTemplate="item">
                    {{ (option.value ? 'Sim' : 'Nao') | translate }}
                  </ng-template>
                </p-dropdown>

              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Tipo_Ficha_do_Evento' | translate}}</label>

                <p-dropdown id="tipoFichaEvento" [options]="tipoFichaEvento" [(ngModel)]="form.tipoFichaEvento"
                  optionLabel="label" placeholder="{{'selecionar' | translate}}" [showClear]="true" styleClass="w-full">
                </p-dropdown>
              </div>

              <div class="form-item form-item-25">
                <label class="pb-2">{{'Nome_do_Evento' | translate}}</label>
                <input type="text" pInputText [(ngModel)]="form.nomeDoEvento"
                  placeholder="{{'Nome_do_Evento' | translate}}" class="input-field" maxlength="50" #nomeInput />
                <div class="caracter-counter">
                  {{nomeInput.value.length || 0}}/50
                </div>
              </div>

              <div class="form-item form-item-25">
  <label class="pb-2">{{'Impressora_Padrao' | translate}}</label>
  <app-select-impressora inputId="Impressora_Padrao" [(ngModel)]="form.impressoraPadraoId"
    [ngModelOptions]="{standalone: true}"></app-select-impressora>
</div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{'Imprimir_Itens_por_Impressora' | translate}}</label>
                <p-dropdown id="imprimirItensDeAcordoImpressora" [options]="imprimirItensDeAcordoImpressora"
                  [(ngModel)]="form.imprimirItensDeAcordoImpressora" optionLabel="label" optionValue="value"
                  placeholder="{{ 'selecionar' | translate }}" [showClear]="false">

                  <ng-template pTemplate="selectedItem">
                    <span
                      *ngIf="form.imprimirItensDeAcordoImpressora !== null && form.imprimirItensDeAcordoImpressora !== undefined">
                      {{ (form.imprimirItensDeAcordoImpressora ? 'Sim' : 'Nao') | translate }}
                    </span>
                  </ng-template>

                  <ng-template let-option pTemplate="item">
                    {{ (option.value ? 'Sim' : 'Nao') | translate }}
                  </ng-template>
                </p-dropdown>
              </div>

              <!-- Impressão automática de PEDIDOS (dedicado) -->
              <div class="form-item form-item-25">
                <label class="pb-2">{{ 'Impressora_Padrao_Pedido' | translate }}</label>
                <app-select-impressora inputId="Impressora_Padrao_Pedido"
                  [(ngModel)]="form.impressoraPadraoPedidoId"
                  [ngModelOptions]="{standalone: true}"></app-select-impressora>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{ 'Imprimir_Auto_Pedido_Local' | translate }}</label>
                <p-dropdown id="imprimirAutomaticoPedidoLocal" [options]="imprimirItensDeAcordoImpressora"
                  [(ngModel)]="form.imprimirAutomaticoPedidoLocal" optionLabel="label" optionValue="value"
                  placeholder="{{ 'selecionar' | translate }}" [showClear]="false">
                  <ng-template pTemplate="selectedItem">
                    <span *ngIf="form.imprimirAutomaticoPedidoLocal !== null && form.imprimirAutomaticoPedidoLocal !== undefined">
                      {{ (form.imprimirAutomaticoPedidoLocal ? 'Sim' : 'Nao') | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">{{ (option.value ? 'Sim' : 'Nao') | translate }}</ng-template>
                </p-dropdown>
              </div>
              <div class="form-item form-item-25">
                <label class="pb-2">{{ 'Imprimir_Auto_Pedido_Minishop' | translate }}</label>
                <p-dropdown id="imprimirAutomaticoPedidoMinishop" [options]="imprimirItensDeAcordoImpressora"
                  [(ngModel)]="form.imprimirAutomaticoPedidoMinishop" optionLabel="label" optionValue="value"
                  placeholder="{{ 'selecionar' | translate }}" [showClear]="false">
                  <ng-template pTemplate="selectedItem">
                    <span *ngIf="form.imprimirAutomaticoPedidoMinishop !== null && form.imprimirAutomaticoPedidoMinishop !== undefined">
                      {{ (form.imprimirAutomaticoPedidoMinishop ? 'Sim' : 'Nao') | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">{{ (option.value ? 'Sim' : 'Nao') | translate }}</ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
    <p-toast />
  </div>
</div>

<!-- Botoes de Acao -->
<div *ngIf="!carregandoDados" class="actions-container">
  <button pButton label="{{'salvar' | translate}}" icon="pi pi-check"
    (click)="submit()" class="btn-primary"></button>
</div>
